import axiosInstance from "auth/FetchInterceptor";

const { COMMON_API } = require("constants/ApiConstant");

const HistoryChangeService = {};

HistoryChangeService.GetHistorychange = function (objectId) {
  return axiosInstance.get(
    `${COMMON_API}/search-full-history-change?objectId=${objectId}`,
    {
      baseURL: process.env.REACT_APP_COMMON_ENDPOINT_URL,
      ContentType: "multipart/form-data",
    }
  );
};

HistoryChangeService.GetHistorychangeOther = function (objectId) {
  return axiosInstance.get(
    `${COMMON_API}/search-full-history-change-other?objectId=${objectId}`,
    {
      baseURL: process.env.REACT_APP_COMMON_ENDPOINT_URL,
      ContentType: "multipart/form-data",
    }
  );
};

export default HistoryChangeService;
